import { UserDocumentTemplate } from 'packages/types'
import { GeneralEditorStore } from 'builder/modules/generalEditor'

export const isResume = (documentType: string): boolean => documentType === 'resume'

export function getTemplates(
  editorState: GeneralEditorStore,
  documentType: string,
): UserDocumentTemplate[] {
  return isResume(documentType) ? editorState.resumeTemplates : editorState.coverLetterTemplates
}
